import { useTranslation } from 'react-i18next';

interface BugReportRowProps {
  onOpen: () => void;
}

/**
 * SC-1082 — la ligne « Signaler un bug » de la feuille d'identité, juste
 * après `NotificationsRow` : le seul endroit où le module vit, aucune place
 * prise sur les écrans eux-mêmes. Le geste (fermer cette feuille, ouvrir
 * `BugReportSheet`) est décidé par l'appelant (`NotesListPage` possède les
 * deux états de feuille) — cette ligne n'est qu'un bouton.
 */
export default function BugReportRow({ onOpen }: BugReportRowProps) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      data-testid="bug-report-row"
      onClick={onOpen}
      className="shrink-0 h-12 rounded-btn border-2 border-ink bg-paper font-sans text-[18px] font-bold text-ink"
    >
      {t('waiter.bugReport.row')}
    </button>
  );
}
